import React, { useContext, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
// import HeaderProgressive from '../../../components/Common/Header/HeaderProgressive';
import ContentApp from '../../../components/ContentApp';
import ContentBottom from '../../../components/ContentBottom';
import ReservationCheckCustomerInfo from '../../../components/ReservationCheck/ReservationCheckCustomerInfo/ReservationCheckCustomerInfo';
import ButtonProccessing, {
  ButtonStatus,
} from '../../../components/Common/ButtonProccessing/ButtonProccessing';
import { WelletContext } from '../../../context/WelletContext';
import useForm from '../../../helpers/useForm';
import { getQueryString } from '../../../helpers/url';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { CircleSpinner } from 'react-spinners-kit';
import { fetchReservation } from '../../../helpers/reservation';
import { putReservation } from '../../../services/reservations/reservationsService';
import styles from './reservationCheck.module.css';
// import ReservationSummary from '../../../components/ReservationCheck/Summary/TransferSummary/ReservationSummary';
import { setCanRefresh } from '../../../actions/appActions';
import Summary from '../../../components/ReservationCheck/Summary/Summary';
import SummaryProducts from '../../../components/ReservationCheck/Summary/SummaryProducts';
import SummaryTransfer from '../../../components/ReservationCheck/Summary/SummaryTransfer';
import EventHeader from '../../../components/Common/EventHeader/EventHeader';
import Header from '../../../components/Common/Header/Header';

const FormCheckTransfer = ({ history }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);
  const reservation = useSelector((state) => state.reservation);
  const countryCode = useSelector((state) => state.app.currentMarket.countryCode);
  const idReservation = getQueryString('id');
  const language = useSelector((state) => state.app.language);
  const appCanRefresh = useSelector((state) => state.app.canRefresh);
  const [loadingDiscount, setLoadingDiscount] = useState(false);

  const [reservationInfo, setReservationInfo] = useState(null);
  const [loadingReservation, setLoadingReservation] = useState(true);
  const [btnStatus, setBtnStatus] = useState(ButtonStatus.Normal);
  const [phoneError, setPhoneError] = useState('');
  const [error, setError] = useState(null);
  const [show, setShow] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!appCanRefresh) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    dispatch(setCanRefresh(false));
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      dispatch(setCanRefresh(true));
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [dispatch, appCanRefresh]);

  const getShow = async () => {
    try {
      const result = await welletContext.apis.tickets.get(`/shows/get/`, {
        params: {
          showId: reservation.showId,
          lang: language,
          details: false,
          reservationType: 'RESTAURANT',
          images: false,
          videos: false,
          IsFeature: false,
        },
      });
      setShow(result.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getReservation = async () => {
    setLoadingReservation(true);
    try {
      const result = await fetchReservation({
        welletContext,
        reservation: {
          ...reservation,
          date: reservation.reservationTransferRequest[0]?.transferDate,
        },
        refReservationId: idReservation,
        reservationTransferRequest: reservation.reservationTransferRequest ?? null,
      });
      if (result.success) setReservationInfo(result.data);
      else console.error(result.error);
    } finally {
      setLoadingReservation(false);
    }
  };

  useEffect(() => {
    getShow();
    getReservation();
  }, []);

  function validate(values) {
    const errors = {};
    if (!values.customerName) errors.customerName = t('nameError.EMPTY_NAME');
    if (!values.customerLastname) errors.customerLastname = t('nameError.EMPTY_LASTNAME');
    if (!values.email) errors.email = t('emailError.EMPTY_EMAIL');
    if (values.phone && !isValidPhoneNumber(values.phone)) {
      errors.phone = t('phoneError.INVALID_PHONE_NUMBER');
      setPhoneError(errors.phone);
    } else {
      setPhoneError('');
    }
    return errors;
  }

  const sendForm = async () => {
    setBtnStatus(ButtonStatus.InProgress);
    setError(null);

    try {
      const result = await putReservation(
        reservation.showId,
        reservation.paxs,
        {
          firstName: values.customerName,
          lastName: values.customerLastname,
          phone: values.phone,
          email: values.email,
        },
        reservation.specialRequests ?? '',
        null,
        countryCode,
        reservation.reservationTransferRequest.trips[0].transferDate,
        reservation.totalAmount ?? null,
        reservation.products ?? null,
        reservation.language ?? 'es',
        reservation.eventId ?? null,
        null,
        reservation.description ?? '',
        null,
        null,
        reservation.refReservationId ?? null,
        welletContext,
        reservation.currency ?? null,
        reservation.customFields ?? null,
        reservation.reservationTransferRequest ?? null,
      );

      setBtnStatus(ButtonStatus.ProgressFinished);
      setTimeout(() => {
        history.push(
          `/reservation-success?reservationType=${result.reservationType}&status=${result.status}`,
        );
      }, 1500);
    } catch (err) {
      console.error(err);
      setBtnStatus(ButtonStatus.Error);
      setError(err.message || 'Error al modificar la reserva');
    }
  };

  const { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

  if (loadingReservation) {
    return (
      <div className='loaderDiv'>
        <CircleSpinner size={40} color='var(--color-font-primary)' />
      </div>
    );
  }

  return (
    <>
      <Header />
      {/* <HeaderProgressive title={t('reservationSetup')} currentStep={4} totalSteps={4} /> */}

      <ContentApp classes='fade-up'>
        <EventHeader
          eventImg={reservationInfo.show.bannerImageUrl}
          eventName={reservationInfo.show.name}
          eventDescription={reservationInfo.show.city.name}
          size='small'
        />
        {/* <div className='text-center fw-600 font-1rem mt-4'>{t('reservationInformation')}</div>
        <div className='text-center fw-400 font-tiny mt-2 pb-4'>{t('reviewBeforeConfirming')}</div> */}
        <div className={styles.paymentSection}>
          <SummaryProducts reservationInfo={reservationInfo} />
        </div>
        
        <SummaryTransfer transfers={reservation.reservationTransferRequest.trips} lng={language} />
        {/* <div className='fw-semibold text-primary font-tiny mb-3'>{t('reservationInformation')}</div> */}
        {reservationInfo.products.some((x) => !x.isCourtesy) && (
          <div
            className={
              `border-none mt-3 position-relative ${loadingDiscount ? styles.disabled : ''} ` +
              styles.paymentSection
            }
          >
            {loadingDiscount && (
              <div className='loading-content'>
                <CircleSpinner
                  className='spinner-app mx-auto'
                  style={{ margin: 'auto' }}
                  size={40}
                  color='var(--color-font-primary)'
                />
              </div>
            )}
            <Summary reservation={reservationInfo} />
          </div>
        )}
        <div className='fw-semibold text-primary font-tiny mb-3'>{t('reservationInformation')}</div>
        <ReservationCheckCustomerInfo
          handleChange={handleChange}
          values={values}
          errors={errors}
          phoneError={phoneError}
          setPhoneError={setPhoneError}
          countryCode={countryCode}
        />
      </ContentApp>

      <ContentBottom>
        <ButtonProccessing
          status={btnStatus}
          text={t('sendPaymentLink')}
          size='large'
          className={styles.btn}
          type='submit'
          onClick={handleSubmit}
          color='#000'
          backgroundColor='var(--color-primary)'
          iconColor='#000'
        />
      </ContentBottom>
    </>
  );
};

export default FormCheckTransfer;
